import { Icon } from '@pairy/pds-react';
import { useAtomValue } from 'jotai';

import { isLeftClickAtom } from '../../../../../store/index.atom';

import * as Styled from './index.styles';

const LeftMoveEffect = () => {
  const isLeftClick = useAtomValue(isLeftClickAtom);
  return (
    <Styled.Container
      justifyContent="center"
      alignItems="center"
      className={isLeftClick ? 'is-active' : undefined}
    >
      <Icon icon={`ph:caret-left`} size={44} color="white" />
    </Styled.Container>
  );
};

export default LeftMoveEffect;
